export default "__VITE_ASSET__416a9c49__"